import * as React from "react"
import { Loader2 } from "lucide-react"

import { cn } from "../lib/utils"

interface SpinnerProps extends React.HTMLAttributes<SVGElement> {
  size?: "sm" | "default" | "lg"
}

function Spinner({ className, size = "default", ...props }: SpinnerProps) {
  const sizeClasses = {
    sm: "size-4",
    default: "size-6",
    lg: "size-8",
  }

  return (
    <Loader2
      className={cn("animate-spin text-primary", sizeClasses[size], className)}
      {...props}
    />
  )
}

interface LoadingSpinnerProps {
  text?: string
  message?: string // Alias for backward compatibility
  size?: "sm" | "default" | "lg"
  fullScreen?: boolean
}

function LoadingSpinner({ 
  text, 
  message,
  size = "default",
  fullScreen = false 
}: LoadingSpinnerProps) {
  const displayText = text || message || "Loading..."
  const content = (
    <div className="flex flex-col items-center justify-center gap-3">
      <Spinner size={size} />
      {displayText && (
        <p className="text-sm text-muted-foreground animate-pulse">{displayText}</p>
      )}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
        {content}
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center p-8">
      {content}
    </div>
  )
}

export { Spinner, LoadingSpinner }
export default LoadingSpinner
